'use client';

import { usePathname } from 'next/navigation';
import HeroV2 from '@/src/components/landing-v2/HeroV2';
import CategoriesV2 from '@/src/components/landing-v2/CategoriesV2';
import ProductsV2 from '@/src/components/landing-v2/ProductsV2';
import TrustBadges from '@/src/components/landing-v2/TrustBadges';
import Newsletter from '@/src/components/landing-v2/Newsletter';
import styles from './landing-v2/page.module.css';

export default function HomePage() {
  const pathname = usePathname();
  const locale = pathname.split('/')[1] || 'en';

  return (
    <div className={styles.page}>
      {/* Hero Carousel */}
      <HeroV2 locale={locale} />

      {/* Categories Section */}
      <CategoriesV2 locale={locale} />

      {/* Products Section */}
      <ProductsV2 locale={locale} />

      {/* Trust Badges */}
      <TrustBadges locale={locale} />

      {/* Newsletter */}
      <Newsletter locale={locale} />
    </div>
  );
}
